import { render, staticRenderFns } from "./MailServerLIst.vue?vue&type=template&id=60d01127&scoped=true&"
import script from "./MailServerLIst.vue?vue&type=script&lang=js&"
export * from "./MailServerLIst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d01127",
  null
  
)

export default component.exports